import './App.css';
import V2HomeCard from './V2HomeCard';
import V2HomeCardItem from './V2HomeCardItem';
import V2HomeCardScreens from './V2HomeCardScreens';
import V2HomeCardCampaigns from './V2HomeCardCampaigns';
import { useNavigate } from 'react-router-dom';
import V2HomeCardAccount from './V2HomeCardAccount';

function V2Home({ menu }) {
    const navigate = useNavigate();

    return (
        <div>
            {menu}
            <div className='v2-home'>
                <V2HomeCardScreens />
                <V2HomeCardCampaigns />
                <V2HomeCardAccount />
                <V2HomeCard
                    icon='pi pi-credit-card'
                    title='Marketplace'
                >
                    <V2HomeCardItem
                        title='Monetize your screens'
                        deactivated={true}
                    />
                    <V2HomeCardItem
                        title='Promote your campaigns'
                        deactivated={true}
                    />
                    <V2HomeCardItem
                        title='Find partnerships'
                        deactivated={true}
                    />
                </V2HomeCard>
                <V2HomeCard
                    icon='pi pi-credit-card'
                    title='Billing'
                >
                    <V2HomeCardItem
                        title='Activate vouchers'
                        deactivated={true}
                    />
                    <V2HomeCardItem
                        title='Invoices'
                        deactivated={true}
                    />
                </V2HomeCard>
            </div>
        </div>
    );
}

export default V2Home;